// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadAllButton_wrapper__mYK07","count":"LoadAllButton_count__Hf0NB"};